// Product rollout switch: keep the team module and its history for a later release.
// Re-enable here when the cabinet-facing workflow is ready.
export const FR_TEAM_UI_ENABLED = false;
